module.exports = __webpack_public_path__ + "static/media/power-25.49636af0.svg";